module.exports = __webpack_public_path__ + "img/005.c98ea344.webp";